// The browser's last errors, kept to go along with a bug report: what broke
// on the page right before the user wrote to us

const LIMIT = 5
const errors: string[] = []

function keep(message: string) {
  errors.push(`${new Date().toISOString().slice(11, 19)} ${message}`)
  if (errors.length > LIMIT) errors.shift()
}

export function installErrorLog() {
  window.addEventListener("error", (event) => {
    keep(event.error instanceof Error ? `${event.error.name}: ${event.error.message}` : String(event.message))
  })
  window.addEventListener("unhandledrejection", (event) => {
    keep(event.reason instanceof Error ? `Unhandled: ${event.reason.message}` : `Unhandled: ${String(event.reason)}`)
  })
}

export const recentErrors = () => [...errors]
